
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compare/best-iga-tools",
      function () {
        return require("private-next-pages/compare/best-iga-tools.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compare/best-iga-tools"])
      });
    }
  